var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliceCarIconDisable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 11C5.27614 11 5.5 10.7761 5.5 10.5C5.5 10.2239 5.27614 10 5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11Z",
    fill: "#0008C3",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 11C17.2761 11 17.5 10.7761 17.5 10.5C17.5 10.2239 17.2761 10 17 10C16.7239 10 16.5 10.2239 16.5 10.5C16.5 10.7761 16.7239 11 17 11Z",
    fill: "#0008C3",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 7C11.2761 7 11.5 6.77614 11.5 6.5C11.5 6.22386 11.2761 6 11 6C10.7239 6 10.5 6.22386 10.5 6.5C10.5 6.77614 10.7239 7 11 7Z",
    fill: "#0008C3",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20 4.7L17.5 4.2C17 4.1 16.55 3.85 16.2 3.5L13.55 0.85C13 0.3 12.25 0 11.45 0H6.75C5.8 0 4.9 0.45 4.35 1.2L3.25 2.7C3.1 2.9 3.15 3.25 3.35 3.4C3.55 3.55 3.85 3.5 4 3.3L5.1 1.8C5.5 1.3 6.05 1 6.7 1H11.4C11.95 1 12.45 1.2 12.8 1.6L15.45 4.25C15.95 4.75 16.55 5.05 17.25 5.2L19.75 5.7C20.45 5.85 20.95 6.45 20.95 7.15V9.5C20.95 9.8 20.75 10 20.45 10H19.4C19.15 8.85 18.15 8 16.95 8C15.75 8 14.75 8.85 14.5 10H9.5V5H14C14.3 5 14.5 4.8 14.5 4.5C14.5 4.2 14.3 4 14 4H9.5V2C9.5 1.7 9.3 1.5 9 1.5C8.7 1.5 8.5 1.7 8.5 2V4H1.5C0.65 4 0 4.65 0 5.5V8.5C0 9.9 1.1 11 2.5 11H2.55C2.8 12.15 3.8 13 5 13C6.4 13 7.5 11.9 7.5 10.5C7.5 9.1 6.4 8 5 8C3.8 8 2.8 8.85 2.55 10H2.5C1.65 10 1 9.35 1 8.5V5.5C1 5.2 1.2 5 1.5 5H8.5V10.5C8.5 10.8 8.7 11 9 11H14.55C14.8 12.15 15.8 13 17 13C18.2 13 19.2 12.15 19.45 11H20.5C21.35 11 22 10.35 22 9.5V7.15C22 5.95 21.15 4.9 20 4.7ZM5 9C5.85 9 6.5 9.65 6.5 10.5C6.5 11.35 5.85 12 5 12C4.15 12 3.5 11.35 3.5 10.5C3.5 9.65 4.15 9 5 9ZM17 12C16.15 12 15.5 11.35 15.5 10.5C15.5 9.65 16.15 9 17 9C17.85 9 18.5 9.65 18.5 10.5C18.5 11.35 17.85 12 17 12Z",
    fill: "#0008C3",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceCarIconDisable);
export default __webpack_public_path__ + "static/media/policeCarIconDisable.04a46575ebc0d2fba24f2e4b03ada2a2.svg";
export { ForwardRef as ReactComponent };